import styled from 'styled-components';

export interface InputLabelProps {
  id: string;
  label: string;
  description?: string;
}

const StyledInputLabel = styled.label`
  display: block;
`;

const InputLabel = ({ id, label, description }: InputLabelProps) => (
  <StyledInputLabel className="cef-ui-input-label" htmlFor={id}>
    <div
      className="cef-ui-input-label__title"
      dangerouslySetInnerHTML={{ __html: label }}
    />

    {description && (
      <div
        className="cef-ui-input-label__description"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    )}
  </StyledInputLabel>
);

export default InputLabel;
